import React from "react";
import LoginForm from "../../components/login-form/login-form";
import Navbar from "../../components/navbar/navbar";

const Login = () => {
  return (
    <>
      <Navbar />
      <LoginForm />
    </>
  );
};

export default Login;
